import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M30 18V30H18L18 18L30 18Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24 9C15.7269 9 9 15.7269 9 24C9 32.2731 15.7269 39 24 39C32.2731 39 39 32.2731 39 24C39 15.7269 32.2731 9 24 9ZM24 6C14.07 6 6 14.07 6 24C6 33.93 14.07 42 24 42C33.93 42 42 33.93 42 24C42 14.07 33.93 6 24 6Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }